import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { usePageMetrics, PageName } from '../../hooks';
import { useRouter } from 'next/router';
import { ErrorPage } from '@dx-ui/osc-error-page';

export type IErrorDisplayProps = {
  statusCode?: number;
};

const ErrorDisplay: React.FC<React.PropsWithChildren<IErrorDisplayProps>> = ({
  statusCode,
}: IErrorDisplayProps): React.ReactElement => {
  const { t, ready } = useTranslation(['common', 'osc-error-page']);
  const { setPageMetrics } = usePageMetrics();
  const router = useRouter();
  const language = router.locale;
  const error = statusCode === 500 ? 'technical' : statusCode === 404 ? '404' : 'unknown';

  React.useEffect(() => {
    const commonData = { brandCode: 'HH', lang: language as string };
    const pageData = {
      errorCode: error,
      errorMessage: t(`osc-error-page:${error}.description`),
    };
    if (ready) {
      setPageMetrics(PageName.ERROR_PAGE, commonData, pageData);
    }
  }, [language, statusCode, setPageMetrics, ready, t, error]);

  return <ErrorPage statusCode={statusCode} />;
};

export default ErrorDisplay;
